module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABH0lEQVQokYXSvyuFcRQG8M99/UpJWEgGpQy2O5swsYjBbuMvMPMHUERZbLL4M8Rq5pZYlIUQdePSqUPX68pTb73f7znPOc95zrdSq9UkNjGNDjT8RIE3nGElIu0ZDvYgDlHPRJncyLxOzGMRo3GxjTFU/I/odoujqLyQ5FZYw0npfgfVID7i4w9iqJjEatNYXXgqmmYoI0x6xT32sJ7xtmjUitCNi5gDN7jEDIabk4oSKaSd4wX76EM/nrPYN8odQ944BlLicP7/QpHfewbqudNTLKcpZcfDk0qQenPRX6imKVvYxUaJGGP0xJM7wFIc/lhJGWHWdRCj6x0ecJxyY68hP2YOw+Ica5jFBEbCnNA8lO907mtPLdyOQleYwsMnnShDYubt/hcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/douyinMch.png
// module id = hzau
// module chunks = 1